module.exports = __webpack_public_path__ + "img/s-tjx-details-top.16a93911.jpg";